export class Answer {
  id: number;
  scoreId: number;
  questionId: number;
  correct: boolean;
}
